import { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  Button,
  TableBody,
  Container,
  TableContainer,
  TablePagination,
  FormControlLabel,
  InputAdornment,
  Stack,
  TextField,
  Grid,
  Paper,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';

import { useSnackbar } from 'notistack';
import { observer } from 'mobx-react-lite';
import MyDialog from 'src/components/MyDialog';
import StatusDelete from './IncomeDelete';

import IncomeTableRow from './IncomeTableRow';
import IncomeTableToolbar from './IncomeTableToolbar';
import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom, TableEmptyRows, TableNoData } from 'src/components/table';
import useSettings from 'src/hooks/useSettings';
import useTable, { getComparator, emptyRows } from 'src/hooks/useTable';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';
import { Incomes } from 'src/@types/Choqorak/MainTables/Income/Income';
import { storeIdToLocalStorage } from 'src/Common/storeIdToLocalStorage';
import { useForm } from 'react-hook-form';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import { DateConverter } from 'src/sections/common/DateConverter';
import Label from 'src/components/Label';
import DownloadIcon from '@mui/icons-material/Download';
import { baseUrl } from 'src/api/baseUrl';

// ----------------------------------------------------------------------

export default observer(function IncomeList() {
  const { IncomeStore, FinancialPaymentStore } = useStore();
  const { translate } = useLocales();
  const {
    loadFinancialPayment,
    FinancialPaymentList,
    FinancialPaymentRegistry
  } = FinancialPaymentStore;
  const {
    loadIncome,
    IncomeList,
    IncomeRegistry,
    totalRecord,
    IncomeSearch,
    deleteIncome,
    getIncomeFromRegistry,
    setOpenCloseDialog,
    setOpenCloseFinancialPaymentDialog,
    openFinancialPaymentsDialog,
    openDialog,
    loadIncomeDetail
  } = IncomeStore;
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    onSort,
    onChangeDense,
    onChangeRowsPerPage,
  } = useTable();

  const { themeStretch, tablePagination, onChangePagination } = useSettings();

  const [filterName, setFilterName] = useState('');
  const [recieveDate, setRecieveDate] = useState<Date | null>(null);

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [IncomeId, setIncomeId] = useState<number>(0);
  const TABLE_HEAD = [
    { id: 'ID', label: `${translate('GeneralFields.No')}`, align: 'left' },
    { id: 'Date', label: `${translate('Income.Date')}`, align: 'left' },
    { id: 'Income Category', label: `${translate('IncomeCategory.IncomeCategory')}`, align: 'left' },
    // { id: 'Currency', label: `${translate('Income.Currency')}`, align: 'left' },
    { id: 'Amount', label: `${translate('Income.Amount')}`, align: 'left' },
    { id: 'Description', label: `${translate('Income.Description')}`, align: 'left' },
    { id: '', label: `${translate('GeneralFields.Action')}` },
  ];
  const methods = useForm({

  });
  const { watch, control } = methods;
  const val = watch()
  const handleFilterName = () => {

    setPage(0);

    if ((filterName && filterName.length > 1) || val.recieveDate) {
      IncomeSearch({
        pageIndex: 0,
        pageSize: tablePagination,
        searchBy: filterName || undefined,
        recieveDate: val.recieveDate ? val.recieveDate : undefined,
      });
    }
    if (val.recieveDate) {
      loadFinancialPayment({
        pageIndex: 0,
        pageSize: tablePagination,
        paymentDate: val.recieveDate ? val.recieveDate : undefined,
      });
    }
    else if (!filterName && !val.recieveDate) {
      IncomeSearch({ pageIndex: 0, pageSize: tablePagination });
    }
  };



  const ResetList = () => {


    IncomeSearch({ pageIndex: 0, pageSize: tablePagination });

  };



  const handleOpenConfirm = (id: number) => {
    setOpenCloseDialog();
    setIncomeId(id);
  };

  const handleCloseConfirm = () => {
    setOpenCloseDialog();
  };

  const handleOpenFinancialPaymentConfirm = () => {
    setOpenCloseFinancialPaymentDialog();

  };

  const handleCloseFinancialPaymentConfirm = () => {
    setOpenCloseFinancialPaymentDialog();
    FinancialPaymentRegistry.clear()
  };
  const handleEditRow = (id: number) => {
    getIncomeFromRegistry(id);
    navigate(PATH_DASHBOARD.Income.edit);
  };

  const handleDetail = (id: number) => {
    storeIdToLocalStorage(id, IncomeStore);
    loadIncomeDetail(id);
    navigate(PATH_DASHBOARD.Income.detail);
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    loadIncome({ pageIndex: newPage, pageSize: tablePagination });
  };
  const handlePageSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangePagination(event.target.value);

    onChangeRowsPerPage(event);
    let pageZize = parseInt(event.target.value);
    loadIncome({ pageIndex: 0, pageSize: pageZize });
  };

  useEffect(() => {
    onChangeRowsPerPage(tablePagination);
    loadIncome({ pageIndex: 0, pageSize: tablePagination });
  }, [loadIncome, tablePagination]);

  useEffect(() => {
    if (IncomeRegistry.size <= 1) {
      loadIncome({ pageIndex: 0, pageSize: rowsPerPage });
    }
  }, []);

  const dataFiltered = applySortFilter({
    tableData: IncomeList,
    comparator: getComparator(order, orderBy),
    filterName: '',
  });

  const denseHeight = dense ? 52 : 72;

  const isNotFound = !dataFiltered.length && !!filterName;
  const Url = baseUrl;

  return (
    <Page title={translate('Income.Title')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Income.IncomeList')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('Income.IncomeList')}` },
          ]}
          action={
            <>
              <PermissionBasedGuard permissions={['Income-Create']}>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  component={RouterLink}
                  to={PATH_DASHBOARD.Income.new}
                >
                  {translate('CRUD.Create')}
                </Button>
              </PermissionBasedGuard>
            </>
          }
        />

        <Card>
          {/* <IncomeTableToolbar filterName={filterName} onFilterName={handleFilterName} control={control} /> */}
          <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}
            sx={{
              display: 'grid',
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(4, 1fr)' },
              py: 2.5, px: 3
            }}
          >
            <LocalizDatePicker
              name="recieveDate"
              label={translate('Income.Date')}
              control={control}


            />
            <TextField
              fullWidth
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}

              placeholder={translate('Income.Placeholder')}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify
                      icon={'eva:search-fill'}
                      sx={{ color: 'text.disabled', width: 20, height: 20 }}
                    />
                  </InputAdornment>
                ),
              }}
            />
            <Box>
              <Button
                sx={{ width: '120px', margin: '2px', padding: '10px' }}
                variant="contained"
                onClick={ResetList}
                startIcon={<Iconify icon="eva:refresh-outline" />}
                size='large'
                color='warning'
              >
                {translate('CRUD.Reset')}
              </Button>
              <Button
                sx={{ width: '120px' }}
                variant="contained"
                onClick={handleFilterName}
                startIcon={<Iconify icon="eva:search-fill" />}
                size='large'
              >
                {translate('Report.Filter')}
              </Button>


            </Box>
            {FinancialPaymentList.length > 0 ? (
              <Box>


                <Button

                  variant="contained"
                  onClick={handleOpenFinancialPaymentConfirm}
                  startIcon={<Iconify icon="eva:search-fill" />}
                  size='large'
                >
                  {translate('Report.FinancialDetails')}
                </Button>
              </Box>
            ) : ''}
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ maxHeight: 600, minWidth: 960, position: 'relative' }}>
              <Table stickyHeader size={dense ? 'small' : 'medium'}>
                <TableHeadCustom
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={totalRecord}
                  onSort={onSort}
                />

                <TableBody>
                  {dataFiltered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <IncomeTableRow
                        key={row.incomeId}
                        row={row}
                        index={index}
                        handleDetail={() => handleDetail(row.incomeId!)}
                        onDeleteRow={() => handleOpenConfirm(row.incomeId!)}
                        onEditRow={() => handleEditRow(row.incomeId!)}
                      />
                    ))}

                  <TableEmptyRows
                    height={denseHeight}
                    emptyRows={emptyRows(page, rowsPerPage, totalRecord)}
                  />

                  <TableNoData isNotFound={isNotFound} />
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <Box sx={{ position: 'relative' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
              component="div"
              labelRowsPerPage={translate('Pagination.RowsPerPage')}
              count={totalRecord}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${translate('Pagination.Of')} ${count}`
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handlePageSizeChange}
            />
            <MyDialog
              open={openDialog}
              onClose={handleCloseConfirm}
              title={translate('CRUD.DeleteTitle')}
              size="md"
            >
              <StatusDelete id={IncomeId} />
            </MyDialog>

            <MyDialog
              open={openFinancialPaymentsDialog}
              onClose={handleCloseFinancialPaymentConfirm}
              title=''
              size="lg"
            >
              <Grid item xs={12} md={12} sx={{ padding: '20px' }}>

                <Card sx={{ p: 2 }}>
                  <Typography
                    variant="h5"
                    sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
                    color="text.secondary"
                    gutterBottom
                  >
                    <Label
                      variant="ghost"
                      sx={{ textTransform: 'capitalize', fontSize: 15, p: 2, marginBottom: '50px' }}
                      color="warning"
                    >
                      {translate('FinancialPayment.FinancialPaymentDetails')}
                    </Label>
                  </Typography>

                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: '100%' }} size="small">
                      <TableBody>
                        <TableRow>

                          <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                            {translate('Report.Dollor')}
                          </TableCell>
                          <TableCell>{FinancialPaymentList[0]?.dollor}</TableCell>

                          <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                            {translate('Report.Afghani')}
                          </TableCell>
                          <TableCell>{FinancialPaymentList[0]?.afghani}</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                            {translate('FinancialPayment.Date')}
                          </TableCell>
                          <TableCell>{<DateConverter date={FinancialPaymentList[0]?.paymentDate} />}</TableCell>
                        </TableRow>

                        <TableRow>



                          <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                            {translate('RentPaymentPrint.SerialNumber')}
                          </TableCell>
                          <TableCell>{FinancialPaymentList[0]?.serialNumber}</TableCell>

                          <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                            {translate('FinancialPayment.Description')}
                          </TableCell>
                          <TableCell>{FinancialPaymentList[0]?.description}</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                            {translate('contractsInfo.Attachments')}
                          </TableCell>
                          <TableCell>
                            <a
                              href={Url + FinancialPaymentList[0]?.attachmentFiles}
                              style={{ color: 'orange' }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <DownloadIcon />
                            </a>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
              </Grid>
            </MyDialog>
            <FormControlLabel
              control={<Switch checked={dense} onChange={onChangeDense} />}
              label={translate('Pagination.Dense')}
              sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
            />
          </Box>
        </Card>
      </Container>
    </Page>
  );
});

// ----------------------------------------------------------------------

function applySortFilter({
  tableData,
  comparator,
  filterName,
}: {
  tableData: Incomes[];
  comparator: (a: any, b: any) => number;
  filterName: string;
}) {
  const stabilizedThis = tableData.map((el, index) => [el, index] as const);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  tableData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    tableData = tableData.filter(
      (item: Record<string, any>) =>
        item.searchBy.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
    );
  }

  return tableData;
}
